import { render, staticRenderFns } from "./ModalMaterialsEvent.vue?vue&type=template&id=48afa574&"
import script from "./ModalMaterialsEvent.vue?vue&type=script&lang=js&"
export * from "./ModalMaterialsEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports